import { BaseBlock } from "./BaseBlock";

import { StickerCardBlock } from "./StickerCardBlock";

import type { Block } from "./Block";

import type { AppState } from "../app/state/AppState";



type Sticker =
    NonNullable<
        AppState["stickers"]
    >[number];

export class StickerListBlock
    extends BaseBlock {

    private readonly stickers: Sticker[];

    private readonly onStickerSelected:
    (stickerId: string) => void;

    private readonly blocks: Block[] = [];

    private root!: HTMLElement;

    constructor(
        stickers: Sticker[],
        onStickerSelected: (
            stickerId: string
        ) => void
    ) {

        super();

        this.stickers = stickers;

        this.onStickerSelected =
            onStickerSelected;

    }

    public override mount(): void {

        this.root =
            document.createElement("div");

        this.root.className =
            "subscriptions-grid";

        this.blocks.length = 0;

        for (const sticker of this.stickers) {

            const block =
                new StickerCardBlock(
                    sticker,
                    this.onStickerSelected
                );

            this.blocks.push(
                block
            );

            block.mount();

            this.root.appendChild(
                block.getRoot()
            );

        }

    }

    public override update(): void {

        for (const block of this.blocks) {
            block.update();
        }

    }

    public override unmount(): void {

        for (const block of this.blocks) {
            block.unmount();
        }

        this.blocks.length = 0;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

}